import React, { useContext } from 'react'
import ColorContext from '../../context/ColorContext'

const Vetted = ({ style }) => {
	const { color } = useContext(ColorContext)
	return (
		<svg
			id="svgVetted"
			className="svgInline"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 225 74.6"
			style={style}
		>
			<linearGradient id="vetGradient" gradientUnits="userSpaceOnUse" x1="11.2893" y1="38.4857" x2="220.4329" y2="-22.9157" gradientTransform="matrix(1 0 0 -1 0 75.8288)">
				<stop  offset="0" style={{ stopColor: color.bravo }} />
				<stop  offset="1" style={{ stopColor: color.alpha }} />
			</linearGradient>
			<path fill="url(#vetGradient)" d="M57 56.2v-.1c0-10.1 7.2-18.5 17.6-18.5 11.9 0 17.3 9.2 17.3 19.3 0 .8-.1 1.7-.1 2.6H67c1 4.6 4.2 7 8.7 7 3.4 0 5.8-1.1 8.6-3.7l5.8 5.1c-3.3 4.1-8.1 6.6-14.5 6.6-10.7.1-18.6-7.4-18.6-18.3zm25.1-3c-.6-4.5-3.2-7.6-7.5-7.6s-6.9 3-7.7 7.6h15.2z" />
			<path fill="url(#vetGradient)" d="M98.6 63.7V46.8h-4.3v-8.6h4.3v-9.1h10.1v9.1h8.4v8.6h-8.4V62c0 2.3 1 3.5 3.2 3.5 1.9 0 3.5-.5 5-1.3v8.1c-2.1 1.3-4.6 2.1-8 2.1-6.1 0-10.3-2.5-10.3-10.7z" />
			<path fill="url(#vetGradient)" d="M124.3 63.7V46.8H120v-8.6h4.3v-9.1h10.1v9.1h8.4v8.6h-8.4V62c0 2.3 1 3.5 3.2 3.5 1.9 0 3.5-.5 5-1.3v8.1c-2.1 1.3-4.6 2.1-8 2.1-6.2 0-10.3-2.5-10.3-10.7z" />
			<path fill="url(#vetGradient)" d="M146.8 56.2v-.1c0-10.1 7.2-18.5 17.6-18.5 11.9 0 17.3 9.2 17.3 19.3 0 .8-.1 1.7-.1 2.6h-24.8c1 4.6 4.2 7 8.7 7 3.4 0 5.8-1.1 8.6-3.7l5.8 5.1c-3.3 4.1-8.1 6.6-14.5 6.6-10.7.1-18.6-7.4-18.6-18.3zm25.1-3c-.6-4.5-3.2-7.6-7.5-7.6s-6.9 3-7.7 7.6h15.2z" />
			<path fill="url(#vetGradient)" d="M187.6 56v-.1c0-11.9 7.8-18.4 16.2-18.4 5.4 0 8.7 2.5 11.1 5.3V25.3H225v48.5h-10.1v-5.1c-2.5 3.3-5.8 5.8-11.1 5.8-8.3-.1-16.2-6.6-16.2-18.5zm27.5 0v-.1c0-5.9-3.9-9.8-8.6-9.8-4.7 0-8.7 3.8-8.7 9.8v.1c0 5.9 4 9.8 8.7 9.8 4.6.1 8.6-3.9 8.6-9.8z" />
			<path fill="url(#vetGradient)" d="M62.9 0 32.3 61.9 13.4 34.1H0l27.4 40.3h11L75.3 0z" />

		</svg>
	)
}

export default Vetted